export class ApplicationLinkChanged {
  constructor(id, linkName) {
    this.id = id;
    this.linkName = linkName;
  }
}